import { AbilityBuilder } from '@casl/ability';
import { SurfaceNodeActions } from 'services/authorization/actions';

export default function defineLinkerPermissions(
  { can }: AbilityBuilder<any>,
  user: string,
): void {
  can(SurfaceNodeActions.read, 'SurfaceNode');
  // Can read surface nodes...that means opening them and reading for example text node or ris document
  can(SurfaceNodeActions.link, 'Surface');

  can(SurfaceNodeActions.unLink, 'SurfaceNodePointsTo', {
    'settings.createdBy': user,
  });
}
